export const DRAW_EVENTS = {
    /** 绘制配置变化 */
    CONFIG_CHANGE: 'brush-config-change',
    /** 绘制结束 */
    DRAW_END: 'brush-draw-end',
};
